import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SignatureState = {
  orderId: string;
  fileUrl: string;
  errorRequest: boolean;
  pinRequested: boolean;
  showAlerts: boolean;
  alertType: string;
  validationPinError: boolean;
  validationPinCode: string;
  signatureCompleted: boolean;
};

export const initialState: SignatureState = {
  orderId: '',
  fileUrl: '',
  errorRequest: false,
  pinRequested: false,
  showAlerts: false,
  alertType: '',
  validationPinError: false,
  validationPinCode: '',
  signatureCompleted: false,
};

const signatureSlice = createSlice({
  name: 'signature',
  initialState,
  reducers: {
    setOrderId: (state, action: PayloadAction<string>): void => {
      state.orderId = action.payload;
    },
    setFileUrl: (state, action: PayloadAction<string>): void => {
      state.fileUrl = action.payload;
    },
    setErrorRequest: (state, action: PayloadAction<boolean>): void => {
      state.errorRequest = action.payload;
    },
    setPinRequested: (state, action: PayloadAction<boolean>): void => {
      state.pinRequested = action.payload;
    },
    setValidationPinError: (state, action: PayloadAction<boolean>): void => {
      state.validationPinError = action.payload;
    },
    setValidationPinCode: (state, action: PayloadAction<string>): void => {
      state.validationPinCode = action.payload;
    },
    setSignatureCompleted: (state, action: PayloadAction<boolean>): void => {
      state.signatureCompleted = action.payload;
    },
    setAlertType: (state, action: PayloadAction<string>): void => {
      state.alertType = action.payload;
    },
    setShowAlerts: (state, action: PayloadAction<boolean>): void => {
      state.showAlerts = action.payload;
    },
  },
});

export const {
  setFileUrl,
  setOrderId,
  setErrorRequest,
  setPinRequested,
  setValidationPinError,
  setValidationPinCode,
  setSignatureCompleted,
  setAlertType,
  setShowAlerts,
} = signatureSlice.actions;

export default signatureSlice.reducer;
